import React, { useState } from "react";
import { Container, Row, Col } from "reactstrap";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { NavLink as RRNavLink } from "react-router-dom";

import { useSelector } from "react-redux";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  initializeUserFromStorage,
  logout,
} from "../../redux/slices/userSlice";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Header = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(initializeUserFromStorage());
  }, [dispatch]);

  const user = useSelector((state) => state.user.user);
  const paymentCards = user?.bankingInfo?.paymentCards || [];
  const depositAccounts = user?.bankingInfo?.depositAccounts || [];
  const isLoggedIn = user?.login;
  const displayName = isLoggedIn
    ? `${user.data.first_name} ${user.data.last_name}`
    : "Guest";

  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  return (
    <div className="header dashboard">
      <Container>
        <Row>
          <Col>
            <Navbar light expand="lg" className="p-0">
              <NavbarBrand to="/home" tag={RRNavLink}>
                <NavbarBrand to="/home" tag={RRNavLink}>
                  <span>Miracle Pace</span>
                </NavbarBrand>
              </NavbarBrand>
              <NavbarToggler onClick={toggle} />
              <Collapse isOpen={isOpen} navbar>
                {isLoggedIn ? (
                  <Nav navbar>
                    <NavItem>
                      <NavLink to="/home" exact tag={RRNavLink}>
                        {t("home.label")}
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink to="/buysell" tag={RRNavLink}>
                        {t("market.label")}
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink to="/settings" tag={RRNavLink}>
                        {t("settings.label")}
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink to="/contactus" tag={RRNavLink}>
                        {t("contactUs.label")}
                      </NavLink>
                    </NavItem>
                  </Nav>
                ) : (
                  <Nav navbar>
                    <NavItem>
                      <NavLink to="/signin" tag={RRNavLink}>
                        {t("signInOrSignUp.label")}
                      </NavLink>
                    </NavItem>
                  </Nav>
                )}
              </Collapse>

              {isLoggedIn && (
                <div className="dashboard_log my-2">
                  <div className="d-flex align-items-center">
                    {paymentCards.length === 0 ||
                      (depositAccounts.length === 0 && (
                        <div className="account_money">
                          <ul>
                            <li className="crypto">
                              <span>
                                {t("complete.info.before.trade.label")}
                              </span>
                            </li>
                          </ul>
                        </div>
                      ))}

                    <UncontrolledDropdown nav inNavbar className="profile_log ">
                      <DropdownToggle nav className="user">
                        <span className="thumb">
                          <i className="la la-user"></i>
                        </span>
                        <span className="name">{displayName}</span>
                        <span className="arrow">
                          <i className="la la-angle-down"></i>
                        </span>
                      </DropdownToggle>
                      <DropdownMenu right>
                        {/* <DropdownItem to="/accounts" tag={RRNavLink}>
                          <i className="la la-user"></i> Account
                        </DropdownItem> */}
                        <DropdownItem to="/history" tag={RRNavLink}>
                          <i className="la la-book"></i> {t("history.label")}
                        </DropdownItem>
                        <DropdownItem to="/settings" tag={RRNavLink}>
                          <i className="la la-cog"></i> {t("settings.label")}
                        </DropdownItem>
                        {/* <DropdownItem to="/lock" tag={RRNavLink}>
                          <i className="la la-lock"></i> Lock
                        </DropdownItem> */}
                        <DropdownItem
                          onClick={() => {
                            dispatch(logout());
                            navigate("/signin");
                          }}
                        >
                          <i className="la la-sign-out"></i>{" "}
                          {t("signOut.label")}
                        </DropdownItem>
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  </div>
                </div>
              )}
            </Navbar>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Header;
